import { ModelBase } from '../../core/model/model-base';
import { ObjectComponentCategory } from '../../rent/model/object-component-category';
import { DwellingInspectionPoint } from './dwelling-inspection-point';
import { DwellingInspectionRoom } from './dwelling-inspection-room';

export class DwellingInspectionPointGroup extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.inspectionPoints = Array.isArray(dataContext.inspectionPoints)
        ? dataContext.inspectionPoints.map(x => new DwellingInspectionPoint(x))
        : [];
      this.componentCategory = dataContext.componentCategory;
      this.dwellingInspectionRoom = dataContext.dwellingInspectionRoom;
      this.caption = dataContext.caption;
    }
  }
  inspectionPoints: DwellingInspectionPoint[];
  caption: string;
  componentCategory: ObjectComponentCategory | string;
  dwellingInspectionRoom: DwellingInspectionRoom | string;
}
